/**
 * 资产路径映射 — 根据数据 ID 导出对应的图片 URL
 * v2: 3D 卡通风格图标 (2026-06-15)
 */
const V = 'v=8e'; // cache busting: RGBA transparency fix for tile icons (2026-06-15 v3)

export const ASSETS = {
  board: {
    full: `/assets/board/board_full.png?${V}`,
  },
  tile: (type: string) => `/assets/board/tile_${type}.png?${V}`,
  char: {
    idle: (charIdx: number) => `/assets/char/char_${String(charIdx).padStart(2, '0')}_*/idle.png?${V}`,
    walk: (charIdx: number) => `/assets/char/char_${String(charIdx).padStart(2, '0')}_*/walk.png?${V}`,
    portrait: (charIdx: number) => `/assets/char/char_${String(charIdx).padStart(2, '0')}_*/portrait.png?${V}`,
    select: (charIdx: number) => `/assets/char/char_${String(charIdx).padStart(2, '0')}_*/select.png?${V}`,
  },
  dice: {
    face: (num: number) => `/assets/dice/dice_${String(num).padStart(2, '0')}.png?${V}`,
    rollSheet: `/assets/dice/dice_roll_spritesheet.png?${V}`,
  },
  cards: {
    backReverse: `/assets/cards/card_back_reverse.png?${V}`,
    backFate: `/assets/cards/card_back_fate.png?${V}`,
    backIdentity: `/assets/cards/card_back_identity.png?${V}`,
    faceReverse: `/assets/cards/card_face_reverse.png?${V}`,
    faceFateGood: `/assets/cards/card_face_fate_good.png?${V}`,
    faceFateBad: `/assets/cards/card_face_fate_bad.png?${V}`,
    icon: (name: string) => `/assets/cards/icons/icon_${name}.png?${V}`,
  },
  ui: {
    logo: '/assets/ui/logo.png',
    panelPlayer: '/assets/ui/panel_player.png',
    btnDice: '/assets/ui/btn_dice_default.png',
    btnDiceHover: '/assets/ui/btn_dice_hover.png',
    btnBuy: '/assets/ui/btn_buy_default.png',
    btnBuyHover: '/assets/ui/btn_buy_hover.png',
    btnSkip: '/assets/ui/btn_skip_default.png',
    btnSkipHover: '/assets/ui/btn_skip_hover.png',
    turnIndicator: '/assets/ui/turn_indicator.png',
    coinIcon: '/assets/ui/coin_icon.png',
    loadingScreen: '/assets/ui/loading_screen.png',
  },
};

/**
 * 根据 characterId (e.g. 'zhaocaimao', 'fox', etc.) → 角色序号 (1-8)
 */
const CHAR_ORDER: Record<string, number> = {
  zhaocaimao: 1,
  fox: 2,
  eagle: 3,
  turtle: 4,
  rabbit: 5,
  dragon: 6,
  owl: 7,
  wolf: 8,
};

export function getCharIndex(characterId: string): number {
  return CHAR_ORDER[characterId] || 1;
}

export function getCharIdlePath(characterId: string): string {
  const idx = getCharIndex(characterId);
  const names = ['zhaocaimao', 'fox', 'eagle', 'turtle', 'rabbit', 'dragon', 'owl', 'wolf'];
  return `/assets/char/char_${String(idx).padStart(2, '0')}_${names[idx - 1]}/idle.png?${V}`;
}

export function getCharWalkPath(characterId: string): string {
  const idx = getCharIndex(characterId);
  const names = ['zhaocaimao', 'fox', 'eagle', 'turtle', 'rabbit', 'dragon', 'owl', 'wolf'];
  return `/assets/char/char_${String(idx).padStart(2, '0')}_${names[idx - 1]}/walk.png?${V}`;
}

export function getCharPortraitPath(characterId: string): string {
  const idx = getCharIndex(characterId);
  const names = ['zhaocaimao', 'fox', 'eagle', 'turtle', 'rabbit', 'dragon', 'owl', 'wolf'];
  return `/assets/char/char_${String(idx).padStart(2, '0')}_${names[idx - 1]}/portrait.png?${V}`;
}

export function getCharSelectPath(characterId: string): string {
  const idx = getCharIndex(characterId);
  const names = ['zhaocaimao', 'fox', 'eagle', 'turtle', 'rabbit', 'dragon', 'owl', 'wolf'];
  return `/assets/char/char_${String(idx).padStart(2, '0')}_${names[idx - 1]}/select.png?${V}`;
}
